import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import SingleUploadField from '../../../../components/fields/SingleUploadField';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { allowedExtensions } from '../../../../utilities/extensions';
import useSystemOptions from '../../../../utilities/useSystemOptions';

const ModelConfiguratorBannerForm = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['modelConfiguratorDetails']);

    const { configurator } = useSystemOptions();

    return (
        <CollapsibleWrapper defaultActiveKey={t('modelConfiguratorDetails:sections.banner')}>
            <Panel
                key={t('modelConfiguratorDetails:sections.banner')}
                header={t('modelConfiguratorDetails:sections.banner')}
            >
                <Row gutter={14}>
                    <Col lg={8} xs={24}>
                        <SingleUploadField
                            {...t('modelConfiguratorDetails:fields.bannerImage', { returnObjects: true })}
                            disabled={disabled}
                            extensions={[...allowedExtensions.image, ...allowedExtensions.video]}
                            name="banner"
                            sizeLimitInMiB={20}
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <SingleUploadField
                            {...t('modelConfiguratorDetails:fields.mobileBannerImage', { returnObjects: true })}
                            disabled={disabled}
                            extensions={[...allowedExtensions.image, ...allowedExtensions.video]}
                            name="mobileBanner"
                            sizeLimitInMiB={20}
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.TranslatedInputField
                            {...t('modelConfiguratorDetails:fields.bannerText', { returnObjects: true })}
                            disabled={disabled}
                            name="bannerText"
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.SelectField
                            {...t('modelConfiguratorDetails:fields.bannerPosition', { returnObjects: true })}
                            disabled={disabled}
                            name="bannerTextPosition"
                            options={configurator.bannerTextPositionOptions}
                            showSearch
                        />
                    </Col>
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default ModelConfiguratorBannerForm;
